export const GEM_CATALOG_PAGE_STORAGE_KEY = "vocabularium_gem_catalog_page";

export function readGemCatalogPage(pageCount) {
  if (!Number.isFinite(pageCount) || pageCount < 1) return 0;

  try {
    const raw = localStorage.getItem(GEM_CATALOG_PAGE_STORAGE_KEY);
    if (raw == null) return 0;
    const page = parseInt(raw, 10);
    if (!Number.isFinite(page) || page < 0 || page >= pageCount) return 0;
    return page;
  } catch {
    return 0;
  }
}

export function writeGemCatalogPage(pageIndex) {
  try {
    localStorage.setItem(GEM_CATALOG_PAGE_STORAGE_KEY, String(pageIndex));
  } catch {
    // ignore quota / privacy mode errors
  }
}
